// Keep the app-rendered navigation label aligned with the bilingual configurator.
(function () {
  var english = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var label = english ? '3D Configurator' : 'Configurateur 3D';
  var target = english ? '/en/pages/price-configurator-flatbeds-campers-1' : '/pages/configurateur-prix-plateformes-campers';
  var scheduled = false;
  var style = document.createElement('style');
  style.textContent = '.main-nav > .freeland-configurator-menu-item{order:-10!important;margin-right:10px}.main-nav > .freeland-configurator-menu-item > a{display:inline-flex!important;align-items:center;min-height:40px;padding:8px 15px!important;border-radius:5px;background:#263329!important;color:#fff!important;font-weight:700!important;letter-spacing:.01em}.main-nav > .freeland-configurator-menu-item > a:hover,.main-nav > .freeland-configurator-menu-item > a:focus-visible{background:#405a43!important;color:#fff!important}@media(max-width:900px){.main-nav > .freeland-configurator-menu-item{margin-right:0}.main-nav > .freeland-configurator-menu-item > a{border-radius:0}}';
  document.head.appendChild(style);
  function update() {
    scheduled = false;
    // The Enterprise menu may not contain the old configurator link. Add the
    // entry inside each primary menu rather than relying on a legacy entry.
    document.querySelectorAll('ul.main-nav').forEach(function (menu) {
      var item = Array.from(menu.children).find(function (child) {
        return child.classList.contains('freeland-configurator-menu-item');
      });
      if (!item) {
        var existing = Array.from(menu.querySelectorAll(':scope > li > a')).find(function (link) {
          return /\/pages\/(configurateur-prix-plateformes-campers|price-configurator-flatbeds-campers-1)(?:[?#]|$)/.test(link.getAttribute('href') || '');
        });
        item = existing ? existing.parentElement : document.createElement('li');
        if (!existing) {
          var link = document.createElement('a');
          link.className = 'main-nav__item main-nav__item--primary main-nav__item-content';
          link.href = target; link.textContent = label;
          item.appendChild(link);
        }
        item.classList.add('freeland-configurator-menu-item');
      }
      if (menu.firstElementChild !== item) menu.insertBefore(item, menu.firstElementChild);
    });
    document.querySelectorAll('a[href*="/pages/"]').forEach(function (link) {
      if (link.closest('.freeland-configurator-host') || link.hasAttribute('data-freeland-product-preset-link') || link.hasAttribute('data-freeland-customer-trucks-link')) return;
      var url;
      try { url = new URL(link.getAttribute('href'), location.origin); } catch (_) { return; }
      if (url.origin !== location.origin || !/^\/(?:en\/)?pages\/(?:configurateur-prix-plateformes-campers|price-configurator-flatbeds-campers-1)\/?$/.test(url.pathname)) return;
      if (link.textContent.trim() !== label) link.textContent = label;
      if (link.getAttribute('title') !== label) link.setAttribute('title', label);
      if (link.getAttribute('href') !== target) link.setAttribute('href', target);
      var menuItem = link.parentElement.matches('.main-nav > li') ? link.parentElement : null;
      if (menuItem) {
        menuItem.classList.add('freeland-configurator-menu-item');
        if (menuItem.previousElementSibling) menuItem.parentElement.insertBefore(menuItem, menuItem.parentElement.firstElementChild);
      }
    });
  }
  function start() {
    update();
    new MutationObserver(function (records) {
      if (scheduled || !records.some(function (record) {
        return Array.from(record.addedNodes).some(function (node) { return node.nodeType === 1; });
      })) return;
      scheduled = true;
      requestAnimationFrame(update);
    }).observe(document.body, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
}());
